import React from 'react'

const Meet = () => {
  return (
    <>
      <div className='main-meet-container'>
        <h1 className='meet-heading heading'>Meet Haylee Canonico</h1>
        <div className='p-meet-container'>
          <p className='meet-p'>
            A lifetime Utahan, Haylee (b. 1995 Durango, CO) is a visual artist working primarily in Printmaking. Specifically, through the mediums of Lithography, Screenprint, and Intaglio. Haylee received her BFA in Painting and Drawing and BA in Art History from College of Fine Arts, University of Utah in 2018. She has exhibited nationally in Salt Lake City, UT, Portland, OR, and Las Vegas, NV. 
          </p>
          <p className='meet-p'>
            Based in Salt Lake City, Haylee enjoys getting outside in the mountains, independent films, and traveling to visit national and international art museums. 
          </p>
          <p className='meet-p'>
            For inquiries and commissions please contact Haylee at: 
          </p>
          <p className='meet-p email'>
            hayleecanonico@gmail.com 
          </p>
          <button className='contact-btn meet-btn'>
            <a href="mailto:hayleecanonico@gmail.com?Subject=Canonico Fine Art Inquiry" target="_top">Contact</a>
          </button>
        </div>
      </div>
    </>
  )
}

export default Meet